type Props = <T>(data: T) => T;

const clone: Props = (data) => {
  return data !== undefined ? JSON.parse(JSON.stringify(data)) : undefined;
};

export default clone;
